
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class StaffPositionsApi extends baseApi {

    getList = async () => {
        return await this.get('?app=staffpositions&act=getList')
    }

}

export default new StaffPositionsApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);
